import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { DashboardFilters, } from '../../../dashboards/components/dashboard_detail/dashboard_filters.component';
import { ReportAnalyticsEvents } from '../../constants/report_analytics_events.constants';
export const DataReportGlobalFilters = ({ isLoading, dashboardData, studyId, environmentId, cubeApi, analyticsEnv, setFilterParams, logReportEvent, disabled = false, layout = 'dialog', }) => {
    const filters = useMemo(() => dashboardData?.filters ?? [], [dashboardData?.filters]);
    const cubeConfigIds = useMemo(() => (dashboardData?.cubeConfigId ? [dashboardData.cubeConfigId] : []), [dashboardData?.cubeConfigId]);
    const handleApply = useCallback((params) => {
        setFilterParams(params);
        if (params.length > 0) {
            logReportEvent?.(ReportAnalyticsEvents.FILTER_APPLIED, {
                filter_type: 'dashboard_global',
                filters_applied: params.map((f) => f.member).join(','),
                filter_count: params.length,
                has_default_value: params.some((param) => {
                    const filter = filters.find((f) => f.key === param.member);
                    return !!filter?.defaultValues?.length;
                }),
            });
        }
    }, [logReportEvent, setFilterParams, filters]);
    const hasFilters = !isLoading && filters.length > 0;
    // Test reports wait for a selected test environment. Prod reports query with the
    // chart client and are not gated on that test environment id.
    const canQueryFilterOptions = analyticsEnv === 'prod' ? !!studyId : !!environmentId;
    const filterRunCount = canQueryFilterOptions && !isLoading ? 1 : 0;
    if (!hasFilters) {
        return null;
    }
    return (_jsx("div", { className: `mb-4${disabled ? ' pointer-events-none opacity-60' : ''}`, "data-testid": 'global-filters', "data-disabled": String(disabled), children: _jsx(DashboardFilters, { filters: filters, studyId: studyId, environmentId: environmentId, runCount: filterRunCount, cubeConfigIds: cubeConfigIds, cubeApi: cubeApi, analyticsEnv: analyticsEnv, onApply: handleApply, layout: layout }) }));
};
